import Vue from 'vue'

import uiDropdown from './src/ui-dropdown.vue';

Vue.component('ui-dropdown', uiDropdown);

export default uiDropdown;



//////////////////
// WEBPACK FOOTER
// ./~/ui-components/~/ui-dropdown/index.js
// module id = 546
// module chunks = 0